import axios from 'axios';

export default class ActiveFlights {

	flights() {
		return axios.get(`${window.configuration.activeFlights.endpoints.edit}?codeType=iata`).then(res => res);
  }

  editFlights(payload) {
		return axios.put(`${window.configuration.activeFlights.endpoints.edit}`, [payload] ).then(res => res);
  }

}